import { getWindowConfig } from "mirador/dist/es/src/state/selectors";
import { createSelector } from "reselect";

/** Selector to get the plugin config for a given window */
var getPluginConfig = createSelector([getWindowConfig], function (_ref) {
  var _ref$canvasNavigation = _ref.canvasNavigation,
    canvasNavigation = _ref$canvasNavigation === void 0 ? {} : _ref$canvasNavigation;
  return canvasNavigation;
});
export { getPluginConfig };